/**
 * Shared badge utility functions for qualification status styling
 */

export type QualificationStatusType = 'qualified' | 'unqualified' | 'unknown';
export type BookedStatusType = 'booked' | 'not_booked';

/**
 * Get badge variant based on qualification and booked status.
 * Booked takes priority over qualification status.
 */
export const getQualificationBadgeVariant = (
  qualificationStatus?: string | null,
  bookedStatus?: string | null
): 'default' | 'secondary' | 'destructive' | 'outline' => {
  if (bookedStatus === 'booked') return 'default';
  if (!qualificationStatus) return 'secondary';
  const normalized = qualificationStatus.toLowerCase();
  if (normalized === 'qualified') return 'default';
  if (normalized === 'unqualified') return 'destructive';
  return 'secondary';
};

/**
 * Get badge CSS class based on qualification and booked status.
 * Booked takes priority over qualification status.
 */
export const getQualificationBadgeClassName = (
  qualificationStatus?: string | null,
  bookedStatus?: string | null
): string => {
  if (bookedStatus === 'booked') {
    return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-800';
  }
  if (!qualificationStatus) return '';
  const normalized = qualificationStatus.toLowerCase();
  if (normalized === 'qualified') {
    return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800';
  }
  if (normalized === 'unqualified') {
    return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 border-red-200 dark:border-red-800';
  }
  return '';
};

/**
 * Get display label based on qualification and booked status.
 * Booked takes priority.
 */
export const getQualificationBadgeLabel = (
  qualificationStatus?: string | null,
  bookedStatus?: string | null
): string => {
  if (bookedStatus === 'booked') return 'Booked';
  if (!qualificationStatus) return 'Unclear';
  const normalized = qualificationStatus.toLowerCase();
  if (normalized === 'qualified') return 'Qualified';
  if (normalized === 'unqualified') return 'Unqualified';
  return 'Unclear';
};
